// Module
var code = "<header> <div class=\"heading\"> <h3>Samples Demo</h3> </div> <div class=\"controls\"> <a class=\"cancel btn icon\"><i class=\"material-icons\">close</i></a> </div> </header> <div class=\"modal-body\"> <video src=\"/webui/app/images/ProductIntroPostgreSQL.mp4\" width=\"1000px\" controls=\"true\" autoplay></video> </div> ";
// Exports
export default code;